export const hasPermission = (permissions, resource, action) => {
    const permission = permissions?.find((p) => p.resource === resource);
    if (!permission) return false;
  
    return permission[action] === true; // ✅ Check if the action is allowed
  };
  
//   export const hasAnyPermission = (permissions, resource, actions) => {

//       const permission = permissions?.find((p) => p.resource === resource);
//       console.log("permission",permission);
//     if (!permission) return false;
  
//     return actions.some((action) => permission[action] === true);
//   };

// export const hasAnyPermission = (permissions, resource, actions) => {
//     const permission = permissions?.find((p) => p.resource === resource);
    
//     console.log("🚀 Checking Permissions for:", resource);
//     console.log("🔍 User Permissions:", permissions);
//     console.log("🎯 Required Actions:", actions);
//     console.log("🔑 Found Permission:", permission);
  
//     if (!permission) return false;
  
//     const hasPermission = actions.some((action) => permission[action] === true);
    
//     console.log("✅ Final Check:", hasPermission);
    
//     return hasPermission;
//   };
  
export const hasAnyPermission = (permissions, resource, actions) => {
    console.log("🚀 Checking Permissions for:", resource);
    console.log("🔍 Full User Permissions Array:", permissions);
    console.log("🎯 Required Actions:", actions);
  
    const permission = permissions?.find((p) => p.resource === resource);
    console.log("🔑 Found Permission:", permission);
  
    if (!permission) {
      console.log("❌ No permission found for resource:", resource);
      return false;
    }
  
    const hasPermission = actions.some((action) => permission[action] === true);
    
    console.log("✅ Final Permission Check:", hasPermission);
    return hasPermission;
  };
  